import { InjectionKey, Ref } from 'vue';
import { DeletedProductsService } from '../../services/deleted-products.service';

export const deletedProductsServiceKey = Symbol() as InjectionKey<Ref<DeletedProductsService>>;
